import {
  Box,
  Text,
  Title,
  Container,
  AvatarIcon1,
  AvatarIcon2,
  AvatarIcon3
} from './FamilyInfo.styles';

import Content from './content';
import { MCD } from '@/services/app';
import { pushEvent } from '@CS/hooks';
import { useForm } from 'react-hook-form';
import { InputField } from '@CS/components/Form';
import type { Family } from '@/services/api/types';
import { useRef, useState, useEffect } from 'react';
import { useTranslation, useDataLayer } from '@CS/hooks';
import InputFieldNumber from '@/components/InputFieldNumber';
import { Content as ContentForm } from '@CS/components/Form';
import AvatarOptionsButtons from '@/components/AvatarOptionsButtons';

export type FamilyData = {
  members: number;
  name: string;
};

type FamilyInfoProps = {
  onSubmit: (value: FamilyData) => void;
  data?: Family;
};

type AppVersion = {
  platform: string;
  version: string;
  build: string;
};

export const FamilyInfo = ({ onSubmit, data }: FamilyInfoProps) => {
  const [focus, setFocus] = useState<boolean>(false);

  const { title, description } = useTranslation(Content);
  const { firstName } = useTranslation(ContentForm);

  const newVersion = useRef(false);

  useDataLayer({
    event: 'page_view',
    eventProperties: {
      page_virtual_path: '/family-mode/volgende/webview',
      page_type: 'family-mode'
    }
  });

  const {
    control,
    register,
    setValue,
    handleSubmit,
    formState: { isSubmitting, isDirty, isValid, errors }
  } = useForm<FamilyData>({
    mode: 'onBlur',
    defaultValues: {
      members: data?.avatars.length || 1,
      name: data?.name || ''
    }
  });

  const onNextClick = () => {
    console.log('onNextClick');
    handleSubmit(onSubmit)();

    pushEvent({
      eventLabel: '/family-mode/volgende',
      eventAction: 'volgende',
      event: 'button_click'
    });
  };

  useEffect(() => {
    MCD.getAppVersion().then((data) => {
      const { version } = data as AppVersion;
      newVersion.current = version.startsWith('3.0');
    });
  }, []);

  return (
    <Container>
      <AvatarIcon1 />
      <AvatarIcon2 />
      <AvatarIcon3 />

      <Box data-testid="info-box" isFocus={focus && !newVersion.current}>
        <Title>{title}</Title>
        <Text>{description}</Text>

        <InputField
          maxlength={30}
          name="familyName"
          setFocus={setFocus}
          error={!!errors.name}
          placeholder={firstName}
          register={register('name', {
            required: true,
            maxLength: 30
          })}
        />

        <InputFieldNumber
          id="members"
          maxValue={8}
          control={control}
          name="familyMembers"
          register={register('members')}
          onChange={(value: number) => {
            setValue('members', value, { shouldDirty: true });
          }}
        />

        <AvatarOptionsButtons
          disabledNext={(!data && !isDirty) || !isValid || isSubmitting}
          onNextClick={onNextClick}
          disabledBack
          disabledSave
        />
      </Box>
    </Container>
  );
};
